import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConnectionTypeResponse } from 'src/app/core/models/connection-type-response';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConnectionTypesApiService {
    baseUrl: string = environment.apiUrl;
    azureLocationsSuffix = 'v1/azure_locations';
    connectionTypesUrlSuffix = 'v1/connection_types';

    constructor(private httpClient: HttpClient) {}

    getConnectionTypes(): Observable<ConnectionTypeResponse[]> {
        return this.httpClient.get<ConnectionTypeResponse[]>(`${this.baseUrl}${this.connectionTypesUrlSuffix}`);
    }
}
